const SupportRequestsIndexPage = () => import('@/pages/support-requests/SupportRequestsIndexPage.vue')
const SupportRequestPage = () => import('@/pages/support-requests/SupportRequestPage.vue')
export default [
  {
    name: 'support-requests-index-page',
    path: 'support-requests',
    component: SupportRequestsIndexPage
  },
  {
    name: 'support-requests-index-page-by-status',
    path: 'support-requests-filtered/:status',
    component: SupportRequestsIndexPage,
    props: (route) => ({ status: route.params.status })
  },
  {
    name: 'support-request-page',
    path: 'support-requests/:supportRequestId',
    component: SupportRequestPage,
    props: (route) => ({ supportRequestId: parseInt(route.params.supportRequestId) })
  }
]
